import { EMAIL_ACTION_TYPE } from '../common/const'

const defaultState = {
  token: '',
  account: '',
  email: '',
  loginKey: '',
  corpName: '',
  corpId: '',
  inviteCode: '',
  redirectUri: '',
  quickRegister: false,
  emailCheckKey: '',
  emailActionType: '', // 注册 或者 找回密码
  lang: navigator.language.substr(0, 2) || '',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
  redirecting: false,
}

export default (state = defaultState, action) => {
  if (action.type === 'setToken') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.token = action.value
    return initState
  }

  if (action.type === 'setAccount') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.account = action.value
    return initState
  }

  if (action.type === 'setEmail') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.email = action.value
    return initState
  }

  if (action.type === 'setLoginKey') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.loginKey = action.value
    return initState
  }

  if (action.type === 'setCorpId') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.corpId = action.value
    return initState
  }

  if (action.type === 'setInviteCode') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.inviteCode = action.value
    return initState
  }

  if (action.type === 'setCorpName') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.corpName = action.value
    return initState
  }

  if (action.type === 'setRedirectUri') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.redirectUri = encodeURIComponent(action.value)
    return initState
  }

  if (action.type === 'setQuickRegister') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.quickRegister = action.value
    return initState
  }

  if (action.type === 'setEmailCheckKey') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.emailCheckKey = action.value
    return initState
  }

  if (action.type === 'setEmailActionType') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.emailActionType = action.value
    return initState
  }

  if (action.type === 'setRedirecting') {
    let initState = JSON.parse(JSON.stringify(state))
    initState.redirecting = action.value
    return initState
  }

  return state
}
